export class ContactBankAccountModel {

    uid: string;
    contactUid: string;
    iban: string;
    bank: string;
    swift: string;
    remesa: boolean;
    
    constructor() { }
}
